import styled from 'styled-components';

const LoadingBox = styled.span`
    ${props => `
        display: inline-block;
        width: 100%;
        ${props.width && `max-width: ${props.width}px`};
        height: ${props.height ? `${props.height}px` : "100%"};
        border-radius: ${props.borderRadius || 0}px;
        background: ${props.background || "#DDE1E6"}; 
        margin: 0px;
        padding: 0px;
    `}
`

export default LoadingBox;